class BidCancellationReason {
    constructor(serverType) {
        this.serverType = serverType;
    }

    translate(t) {
        return t(`auctions.bid-cancellation-reason.${this.serverType.toLowerCase().replace(/_/g, '-')}`);
    }

    is(bidCancellationReason) {
        return bidCancellationReason === this;
    }
}

export const UNKNOWN = new BidCancellationReason('UNKNOWN');
export const MANUALLY_CANCELLED = new BidCancellationReason('MANUALLY_CANCELLED');
export const AUCTION_LIMIT_EXCEEDED = new BidCancellationReason('AUCTION_LIMIT_EXCEEDED');
export const CASH_LIMIT_EXCEEDED = new BidCancellationReason('CASH_LIMIT_EXCEEDED');
export const MEMBER_SUSPENDED = new BidCancellationReason('MEMBER_SUSPENDED');
export const USER_SUSPENDED = new BidCancellationReason('USER_SUSPENDED');
export const REPLACED_BY_UPLOAD = new BidCancellationReason('REPLACED_BY_UPLOAD');
export const MEMBER_UNASSIGNED = new BidCancellationReason('MEMBER_UNASSIGNED');
export const ZONE_UNASSIGNED = new BidCancellationReason('ZONE_UNASSIGNED');
export const ZONE_FORBIDDEN = new BidCancellationReason('ZONE_FORBIDDEN');

export const getBidCancellationReason = (serverType) => {
    let result = null;
    switch (serverType) {
        case 'UNKNOWN':
            result = UNKNOWN;
            break;
        case 'MANUALLY_CANCELLED':
            result = MANUALLY_CANCELLED;
            break;
        case 'AUCTION_LIMIT_EXCEEDED':
            result = AUCTION_LIMIT_EXCEEDED;
            break;
        case 'CASH_LIMIT_EXCEEDED':
            result = CASH_LIMIT_EXCEEDED;
            break;
        case 'MEMBER_SUSPENDED':
            result = MEMBER_SUSPENDED;
            break;
        case 'USER_SUSPENDED':
            result = USER_SUSPENDED;
            break;
        case 'REPLACED_BY_UPLOAD':
            result = REPLACED_BY_UPLOAD;
            break;
        case 'MEMBER_UNASSIGNED':
            result = MEMBER_UNASSIGNED;
            break;
        case 'ZONE_UNASSIGNED':
            result = ZONE_UNASSIGNED;
            break;
        case 'ZONE_FORBIDDEN':
            result = ZONE_FORBIDDEN;
            break;
        default:
            throw new Error(`Unknown bid cancellation reason: ${serverType}`);
    }
    return result;
};

export const getAllBidCancellationReasons = () => [
    UNKNOWN,
    MANUALLY_CANCELLED,
    AUCTION_LIMIT_EXCEEDED,
    CASH_LIMIT_EXCEEDED,
    MEMBER_SUSPENDED,
    USER_SUSPENDED,
    REPLACED_BY_UPLOAD,
    MEMBER_UNASSIGNED,
    ZONE_UNASSIGNED,
    ZONE_FORBIDDEN,
];
